import React, { PureComponent } from 'react';
import { scaleLinear } from 'd3-scale';

import './table.styl';

function getRank(d, i, data) {
  if (i === 0) {
    return 1;
  }

  if (data[i - 1].value !== d.value) {
    return i + 1;
  }

  return '';
}

class Table extends PureComponent {
  renderRows = () => {
    const { data, valueKey, cvalueKey } = this.props;

    if (!data) {
      return null;
    }

    const topData = data
      .filter(d => !isNaN(parseInt(d[valueKey])))
      .map(d => ({
        value: parseInt(d[valueKey]),
        name: d.land,
        cvalue: (d[cvalueKey].toFixed(2))
      }))
      .sort((a, b) => a.value - b.value);

    const percScale = scaleLinear().domain([0, -57340]).range([0, 100]).clamp(true);

    return topData.map((d, i) => (
      <div key={d.name} className="t-row">
        <div className="t-data t-data-1">
          <div className="rank">{getRank(d, i, topData)}</div>
          <div className="name">{d.name}</div>
        </div>
        <div className="t-data t-data-2">
          <div className="t-value">{d.value}&nbsp;&nbsp;<small className="rank">({d.cvalue} %)</small> </div>
          <div className="t-chart bar-wrapper">
            <div className="bar" style={{ width: percScale(d.value) + '%' }}></div>
          </div>
        </div>
      </div>
    ));
  }

  render() {
    return (
      <div className="brexit-table t-flex">
        <div className="t-head">
          <div className="t-row">
            <div className="t-data t-data-1">Land</div>
            <div className="t-data t-data-2"><strong className="t-value">Verlust in Mio. €</strong></div>
          </div>
        </div>

        <div className="t-body">
        {this.renderRows()}
        </div>
      </div>
    );
  }
}

export default Table;
